<template>
    <!-- Search Address -->
    <search-text-input class="md-layout-item md-size-100"
        label="Search Address" icon="search"
        :prefixLabel="prefixLabel"
        v-model="address.full_address"
        :disabled="disabled"
        :searcher="debouncedSearchFn"
        :manual-search-trigger="true"
        @select="selectAddress"
        min-length="5"
        >
        <template v-slot="{ item }">
          {{ item.full_address }}
        </template>
    </search-text-input>
</template>

<script>
import ValidatedInputs from '@/components/ValidatedInput';
import debounce from 'lodash/debounce';

export default {
    components: {
        ...ValidatedInputs,
    },
    props: {
        address: {
            type: Object,
            default: {},
        },
        prefixLabel: {
            type: String,
            default: '',
        },
        disabled: false
    },
    data(){
        return {
            full_address: '',
            debouncedSearchFn: null
        };
    },
    created() {
        let resolver = null;

        const debounced = debounce(async (query) => {
            if (!query || query.length < 5) {
            if (resolver) resolver([]);
                return;
            }
            try {
                const response = await this.$store.dispatch("performSearchAddress", {
                    formatted_address: query,
                });
                if (resolver) resolver(response.data?.addresses || []);
            } catch (error) {
                console.error(error);
                if (resolver) resolver([]);
            } finally {
                resolver = null;
            }
        }, 1500);

        this.debouncedSearchFn = (query) => {
            return new Promise((resolve) => {
                resolver = resolve;
                debounced(query);
            });
        };
    },
    methods: {
        async selectAddress(result) {
            try {
                let id = result.id;
                let params = {
                    id: id,
                    result: result,
                };
                let response = await this.$store.dispatch("selectAddressMethod", params);
                this.$emit('update-address', response.data)
            } catch(error) {
                console.error(error);
            }
        },
    },
}
</script>
